import { render, staticRenderFns } from "./NodeSettings.vue?vue&type=template&id=031d2655"
import script from "./NodeSettings.vue?vue&type=script&lang=ts"
export * from "./NodeSettings.vue?vue&type=script&lang=ts"
import style0 from "./NodeSettings.vue?vue&type=style&index=0&id=031d2655&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports